import React, { useState, useEffect, useLayoutEffect } from "react";
import { useHistory } from "react-router-dom";
import { Endpoints } from "../../repository/Endpoints";
import { PostMaker } from "../../repository/RequestMaker";
import { Language } from "./Language";
import MonthsTranslated from "./MonthsTranslated";
import validator from "email-validator";
import Swal from "sweetalert2";

const Userdata = () => {
  //inits
  const history = useHistory();
  const webcamRef = React.useRef(null);
  const [userphoto, setUserphoto] = useState("");
  const [day_val, setDayVal] = useState(1);
  const [month_val, setMonthVal] = useState(1);
  const [year_val, setYearVal] = useState(2000);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [company, setCompany] = useState("");
  const [userdob, setUserdob] = useState("");
  const [emailIsValid, setEmailIsValid] = useState(false);
  const language = localStorage.getItem("language");


  useEffect(() => {
    const storedFirstName = localStorage.getItem("username")?.split(" ")[0] || "";
    const storedLastName = localStorage.getItem("username")?.split(" ")[1] || "";
    const storedEmail = localStorage.getItem("useremail") || "";
    const storedCompany = localStorage.getItem("usercompany") || "";
    const storedDob = localStorage.getItem("userdob") || "";

    if (storedFirstName) setFirstName(storedFirstName);
    if (storedLastName) setLastName(storedLastName);
    if (storedEmail) {
      setEmail(storedEmail);
      setEmailIsValid(validator.validate(storedEmail)); // Set email validity immediately
    }
  if (storedCompany) setCompany(storedCompany);
    if (storedDob) setUserdob(storedDob);
  }, []);

  //logics
  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setUserphoto(imageSrc);
  }, [webcamRef]);

  const toggleVisibility = (id) => {
    window.scrollTo(0, 0);
    var jumbos = [
    //   "dob_jumbotron",
    //   "email_jumbotron",
    //   "company_jumbotron",
    //   "lastname_jumbotron",
    //   "firstname_jumbotron",
    //   "photo_jumbotron",
       "datepicker_jumbotron",
    ];

    for (let index = 0; index < jumbos.length; index++) {
      const jumbo = jumbos[index];
      var x = document.getElementById(jumbo);
      x.style.display = "none";
    }
    var x = document.getElementById(id);
    x.style.display = "block";
  };

  const onMonthChange = (value) => {
    setMonthVal(value);
    date_validity(value);
  };

  const date_validity = (month) => {
    var day = day_val;
    console.log(day, month);
    month = parseInt(month);
    day = parseInt(day);
    if (month === 4 || month === 6 || month === 9 || month === 11) {
      if (day > 30) {
        Swal.fire({
          text: "Ungültiger Tag für den gewählten Monat ausgewählt/ Invalid day selected for selected month",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#073e87",
        });
      }
    } else if (month === 2) {
      if (day > 29) {
        Swal.fire({
          text: "Ungültiger Tag für den gewählten Monat ausgewählt/ Invalid day selected for selected month",
          icon: "error",
          confirmButtonText: "OK",
          confirmButtonColor: "#073e87",
        });
      }
    }
  };
  const set_date = () => {
    var day = parseInt(day_val);
    var month = parseInt(month_val);
    var month_name =
      document.getElementById("month_setter").options[month].text;
    var year = parseInt(year_val);
    var leap_year = year % 4;
    var allgood = true;
    if (day === "Day") {
      Swal.fire({
        text: "Bitte wählen Sie einen Tag / Please select a day",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#073e87",
      });
      allgood = false;
    }
    if (month === "Month") {
      Swal.fire({
        text: "Bitte wählen Sie einen Monat / Please select a month",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#073e87",
      });
      allgood = false;
    }
    if (day > 29 && month === "2") {
      Swal.fire({
        text: "Ungültiges Datum / Invalid Date",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#073e87",
      });
      allgood = false;
    }
    if (day === 29 && month === 2 && leap_year !== 0) {
      Swal.fire({
        text: "Ungültiges Datum / Invalid Date",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#073e87",
      });
      allgood = false;
    }
    if (
      day === 31 &&
      (month === 4 || month === 6 || month === 9 || month === 11)
    ) {
      Swal.fire({
        text: "Ungültiges Datum / Invalid Date",
        icon: "error",
        confirmButtonText: "OK",
        confirmButtonColor: "#073e87",
      });
      allgood = false;
    }
    if (allgood) {
      console.log(
        `${month_name} ${
          day.toString().length === 1 ? "0" + day : day
        }, ${year}`
      );
      //console.log('day',day,'month',month,'year',year,'month_name',month_name);
      document.getElementById("userdob").value = `${month_name} ${
        day.toString().length === 1 ? "0" + day : day
      }, ${year}`;
      document.getElementById("userdob_val").value = `${year}-${
        month.toString().length === 1 ? "0" + month : month
      }-${day.toString().length === 1 ? "0" + day : day}`;
      toggleVisibility("dob_jumbotron");

      setUserdob(
        `${year}-${month.toString().length === 1 ? "0" + month : month}-${
          day.toString().length === 1 ? "0" + day : day
        }`
      );
    }
  };


  /**
   * New Approach my not to double the entries
   */

  const createCalendar = () => {
    var d = new Date();
    var current_year = d.getFullYear();
    var language = localStorage.getItem("language");
    var month_arr = MonthsTranslated[language];
    
    // Determine the "Please Select" text based on the language
    var selectText = language === "de" ? "Bitte auswählen" : "Please Select";
    
    // Get the currently selected values
    const selectedDay = document.getElementById("day_setter").value;
    const selectedMonth = document.getElementById("month_setter").value;
    const selectedYear = document.getElementById("year_setter").value;
  
    // Clear existing options
    document.getElementById("day_setter").innerHTML = '';
    document.getElementById("month_setter").innerHTML = '';
    document.getElementById("year_setter").innerHTML = '';
  
    // Append initial option for day
    document.getElementById("day_setter").innerHTML += `<option value="" disabled>${selectText}</option>`;
  
    // Append day options
    for (let day = 1; day < 32; day++) {
      document.getElementById("day_setter").innerHTML += `<option value="${day}">${day}</option>`;
    }
  
    // Set the previously selected day, if any
    if (selectedDay) {
      document.getElementById("day_setter").value = selectedDay;
    } else {
      document.getElementById("day_setter").value = "";
    }
  
    // Append initial option for month
    document.getElementById("month_setter").innerHTML += `<option value="" disabled>${selectText}</option>`;
  
    // Append month options
    for (let month = 1; month < 13; month++) {  // Changed to 12 for correct month index range
      const monthOption = `<option value="${month}">${month_arr[month]}</option>`;
      document.getElementById("month_setter").innerHTML += monthOption;
    }
  
    // Set the previously selected month, if any
    if (selectedMonth) {
      document.getElementById("month_setter").value = selectedMonth;
    } else {
      document.getElementById("month_setter").value = "";
    }
  
    // Append initial option for year
    document.getElementById("year_setter").innerHTML += `<option value="" disabled>${selectText}</option>`;
  
    // Append year options
    for (let year = 1900; year <= current_year; year++) {  // Include current year
      document.getElementById("year_setter").innerHTML += `<option value="${year}">${year}</option>`;
    }
  
    // Set the previously selected year, if any
    if (selectedYear) {
      document.getElementById("year_setter").value = selectedYear;
    } else {
      document.getElementById("year_setter").value = "";
    }
  
    toggleVisibility("datepicker_jumbotron");
  };

  const storeData = (e) => {
    e.preventDefault();
    document.getElementById("confirm").innerHTML = "Wait...";
    console.log(
      "userdata",
      firstName,
      lastName,
      email,
      company,
      userdob,
      userphoto.substring(0, 30)
    );
    if (
      // userphoto !== "" &&
      firstName !== "" &&
      lastName !== "" &&
      email !== "" &&
      company !== "" &&
      userdob !== ""
    ) {
      localStorage.setItem("username", firstName + " " + lastName);
      localStorage.setItem("useremail", email);
      localStorage.setItem("usercompany", company);
      localStorage.setItem("userdob", userdob);
      // localStorage.setItem("userphoto", userphoto);
      PostMaker(
        {
          first_name: firstName,
          last_name: lastName,
          mobile: "01234",
          email: email,
          birth_date: userdob,
          lang: 1,
          trade: "tester",
          company: company,
          user_image:
            "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
          personal_code: "",
          tenant_id: localStorage.getItem("tenant_id"),
        },
        Endpoints.register
      ).then((res) => {
        if (res) {
          localStorage.setItem("token", res.token);
          localStorage.setItem("user_id", res.user_id);
          localStorage.setItem("profile_id", res.profile_id);
          const trainingId= localStorage.getItem("selected_training_id");

          // Call 
          PostMaker(
            {
              user_id: res.user_id,
              course_id: localStorage.getItem('selected_project_id'),// project ID 
              profile_id: res.profile_id,
            },
            Endpoints.enrollment
          ).then((response) => {
            if (response) {
              localStorage.setItem("enrollment_id", response.data.id);
              history.push(`/materials/${trainingId}`);
            }
          })
        } else {
          document.getElementById("confirm").innerHTML = "Next";
        }
      });
    } else {
      Swal.fire({
        text: "Überprüfen Sie, ob das Formular vollständig ausgefüllt ist und ob das Foto im rechten Bereich ordentlich angezeigt wird.",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#073e87",
      });
    }
  };

  const setEmailWithValidation = (val) => {
    var isValid = validator.validate(val);
    if (isValid) {
      setEmailIsValid(true);
    } else {
      setEmailIsValid(false);
    }
    setEmail(val);
  };
  useEffect(() => {
    toggleVisibility("photo_jumbotron");
    //toggleVisibility("dob_jumbotron");
  }, []);

  useLayoutEffect(() => {
    // Translations("", Language);
  }, []);
  return (
    <div id="userdata_container">
      <div
        className="bg-mine"
        id="photo_jumbotron"
        style={{ marginBottom: "70px" }}
      >
        <h1 className="text-title-color" id="title">
          {Language[language].title}
        </h1>
        <p className="lead text-subtitle-color" id="subtitle">
          {Language[language].subtitle}
        </p>
        <hr className="my-4 title_underline" />

      {/* Vorname */}

      <div>
        {/* <span className="userdata_title" id="username_tag">
          {Language[language].username_tag}
        </span> */}
        {/* <hr className="my-4 text-title-color" /> */}
        <div className="input-group mb-3">
          <input
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            type="text"
            className="form-control input"
            placeholder={Language[language].username_muted}
            id="username"
            required
          />
        </div>
      </div>

      {/* Nachname */}
        {/* <span className="userdata_title" id="usersurname_tag">
          {Language[language].usersurname_tag}
        </span>
        <hr className="my-4 text-title-color" /> */}
        <div className="input-group mb-3">
          <input
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            type="text"
            className="form-control input"
            placeholder={Language[language].usersurname_muted}
            id="usersurname"
            required
          />
      </div>

      {/* Company Name */}

        {/* <span className="userdata_title" id="usercompany_tag">
          {Language[language].usercompany_tag}
        </span>
        <hr className="my-4 text-title-color" /> */}
        <div className="input-group mb-3">
          <input
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            type="text"
            className="form-control input"
            placeholder={Language[language].usercompany_muted}
            id="usercompany"
          />
        </div>

      {/* Email  */}
        {/* <span className="userdata_title" id="email_tag">
          {Language[language].email_tag}
        </span>
        <hr className="my-4 text-title-color" /> */}
        <div className="input-group mb-3">
          <input
            value={email}
            onChange={(e) => {
              setEmailWithValidation(e.target.value);
              // setEmail(e.target.value);
            }}
            type="email"
            className="form-control input"
            placeholder={Language[language].email_muted}
            id="usercontact"
          />
      </div>

      <div id="dob_jumbotron">
{/* 
        <span className="userdata_title" id="dob_tag">
          {Language[language].dob_tag}
        </span>
        <hr className="my-4 text-title-color" /> */}
        <div className="input-group mb-3">
          <input
            onClick={createCalendar}
            type="text"
            id="userdob"
            className="form-control input"
            placeholder={Language[language].dob_muted}
            required
          />
          <input hidden type="text" id="userdob_val" />
      </div>
</div>
      <div id="datepicker_jumbotron">
        <div className="row" style={{ padding: "20px" }}>
          <div className="col">
            <div className="row" id="day_picker_label">
              <span className="userdata_title">
                {Language[language].day_picker_label}
              </span>{" "}
              <br /> <br />
            </div>
            <div className="row">
              <select
                className="btn btn-tennet"
                id="day_setter"
                onChange={(e) => setDayVal(e.currentTarget.value)}
              >
                <option selected disabled></option>
              </select>
            </div>
          </div>

          <div
            className="col"
            style={{ marginLeft: "10px", marginRight: "10px" }}
          >
            <div className="row" id="month_picker_label">
              <span className="userdata_title">
                {Language[language].month_picker_label}
              </span>{" "}
              <br /> <br />
            </div>
            <div className="row">
              <select
                className="btn btn-tennet"
                id="month_setter"
                onChange={(e) => onMonthChange(e.currentTarget.value)}
              >
                <option selected disabled></option>
              </select>
            </div>
          </div>

          <div className="col">
            <div className="row" id="year_picker_label">
              <span className="userdata_title">
                {Language[language].year_picker_label}
              </span>{" "}
              <br /> <br />
            </div>
            <div className="row">
              <select
                className="btn btn-tennet"
                id="year_setter"
                onChange={(e) => setYearVal(e.currentTarget.value)}
              ></select>
            </div>
          </div>
        </div>
        <br />
        <div className="d-flex justify-content-end">
          <button
            type="button"
            onClick={set_date}
            //className="btn btn-outline-dark col-1"
            className="btn-round"
          >
            <i class="fa fa-save icon-border" aria-hidden="true"></i>{" "}
            {Language[language].button_save_dob}
          </button>
        </div>
        {/* <div className="row" style={{ padding: "20px" }}>
          <div className="col-11"></div>
          <div className="col-1">
            <button
              type="button"
              onClick={set_date}
              //className="btn btn-outline-dark col-1"
              className="btn-smol"
            >
              OK
            </button>
          </div>
        </div> */}
      </div>




      <div className="d-flex flex-wrap justify-content-between">
            
            {firstName === "" || lastName === ""  || userdob === "" || !emailIsValid  ? (
              <></>
            ) : (
              <button
                type="button"
                className="btn-round margin_right"
                onClick={storeData}
                id="confirm"
              >
                {Language[language].button_start_training}
              </button>
            )}
          </div>

      </div>
    </div>
  );
};
const videoConstraints = {
  facingMode: "user",
};
export default Userdata;
